import { createTheme } from "@mui/material/styles";

const interFont = '"Inter", sans-serif';
const serifFont = '"Georgia", serif'; // or whatever serif you prefer

export default createTheme({
    palette: {
      primary: {
        main: "#2DA894",         // Green for main brand color or active state
        light: "#DFF0EE",        // Very light green for hover or background
        dark: "#1E7F6E",         // Darker version for hover or border
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#5F6368",         // Neutral gray for text/icons
        light: "#F1F3F4",        // Light gray for backgrounds or subtle borders
      },
      error: {
        main: "#EA4335",         // Red for errors (from the "Error" badge)
        light: "#FDECEA",        // Light red background
      },
      warning: {
        main: "#F9AB00",         // Amber (optional, for "Queued" or similar)
        light: "#FFF7E6",
      },
      success: {
        main: "#2DA894",         // Same green as primary
        light: "#E6F4F2",
      },
      info: {
        main: "#5E97F6",         // Blue (optional, if you use info statuses)
        light: "#E8F0FE",
      },
      background: {
        default: "#FFFFFF",      // Main page background
        paper: "#FAFAFA",        // Card/section backgrounds
      },
      divider: "#E0E0E0",        // Light gray lines in tables
      text: {
        primary: "#1D293B",      // Dark gray text
        secondary: "#5F6368",    // Lighter gray text
      },
      common: {
        greyAccent: "#d7d2cb",
        greyBackground: "#f7f7f7",
        greyBorder: "#d9d9d9",
        grey: "#999",
      },
    },
    
  typography: {
    fontFamily: interFont,
    serif: {
      fontFamily: serifFont,
    },
    sansSerif: {
      fontFamily: interFont,
    },
    h1: {
      fontSize: "3.6rem",
      fontFamily: serifFont,
      fontWeight: "bold",
      lineHeight: 1.25,
    },
    subtitle1: {
      fontSize: "1.44rem",
      fontFamily: interFont,
    },
    breadcrumb: {
    fontSize: "1rem", // 16px
    fontFamily: interFont,
    fontWeight: 400,
  },
    paragraph: {
      fontSize: "0.875rem",
      fontFamily: interFont,
    },
  },
});
